module.exports = __webpack_public_path__ + "static/rakesh-soni-1b7cd4add7533c7482f91e2a518cdf12.webp";